/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { ReactElement, useRef, useEffect } from 'react';

import { B2CResult as B2C_RESULT, herbDesc } from '@constants/b2c';
import { Page } from '@constants/enum';
import { useReduxForm } from '@hooks/useReduxForm';

import KakaoShareButton from '../../KakaoShareButton';

function B2CSolution({ setPageIndex }: { setPageIndex: any }): ReactElement {
  const { formData = { bResult: undefined } } = useReduxForm('b2cResult');
  const { formData: mbtiFlowFormData } = useReduxForm('mbtiFlow');
  const scrollAreaRef = useRef(null);

  useEffect(() => {
    const scrollToTop = () => {
      if (scrollAreaRef.current) {
        scrollAreaRef.current.scrollIntoView({ block: 'start' });
      }
    };

    // 컴포넌트가 마운트된 후 약간의 지연을 두고 스크롤을 조정합니다.
    const timeoutId = setTimeout(scrollToTop, 0);

    // 클린업 함수
    return () => clearTimeout(timeoutId);
  }, [scrollAreaRef]);

  return (
    <div
      ref={scrollAreaRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '14px 15px 20px 15px',
        background: '#C2D5EB',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#FFFFFF',
          width: '100%',
          padding: '35px 20px 15px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontSize: '16px',
              color: '#666666',
              fontWeight: 700,
              lineHeight: '1.3125em',
              letterSpacing: '-0.64px',
            }}
          >
            {`${localStorage.getItem('survey-name') ?? ''}님의 분석 결과`}
          </span>
        </div>
        <div
          style={{
            marginTop: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontSize: '24px',
              fontWeight: 700,
              lineHeight: '1.2em',
              color: '#2B8FFF',
              letterSpacing: '-0.96px',
            }}
          >
            내 몸에 맞는 약재
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              marginTop: '15px',
              position: 'relative',
              display: 'flex',
              rowGap: '20px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {B2C_RESULT[formData?.bResult?.판정결과]?.herb?.map((h) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <img alt={h} src={`${process.env.PUBLIC_URL}/img/${h}.webp`} width="100%" />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#2B8FFF33',
                    height: '32px',
                    width: '100%',
                  }}
                >
                  <span
                    style={{
                      marginBottom: '-2px',
                      color: '#2B8FFF',
                      fontSize: '18px',
                      fontWeight: 700,
                      lineHeight: '1.2em',
                      letterSpacing: '-0.72px',
                    }}
                  >
                    {h}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#D9D9D933',
                    width: '100%',
                    padding: '10px',
                    borderBottom: '1px solid #E5E5E5',
                  }}
                >
                  <span
                    style={{
                      color: '#1D1C1D',
                      fontSize: '16px',
                      lineHeight: '1.4375em',
                      letterSpacing: '-0.64px',
                    }}
                  >
                    {herbDesc[h].desc}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '5px' }}>
          <span
            style={{
              marginTop: '1px',
              color: '#afafaf',
              fontSize: '11px',
              letterSpacing: '-0.4px',
              lineHeight: '1.2em',
            }}
          >
            이미지 출처: 김창민, 2015 한약재감별도감 2 : 외부형태, 아카데미서적, 2014.
          </span>
        </div>
      </div>
      <div
        style={{
          marginTop: '25px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          rowGap: '8px',
        }}
      >
        <button
          onClick={() => setPageIndex(Page.B2CResult)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#2B8FFF',
            width: 'calc(100% - 32px)',
            height: '52px',
            borderRadius: '20px',
            border: 'none',
            color: '#ffffff',
            fontSize: '20px',
            fontWeight: 700,
            letterSpacing: '0.1px',
          }}
          type="button"
        >
          이전으로
        </button>
        {!mbtiFlowFormData?.uuid && <KakaoShareButton />}
        {!mbtiFlowFormData?.uuid && (
          <button
            onClick={() => setPageIndex(Page.B2CMain)}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: '#FFFFFF',
              width: 'calc(100% - 32px)',
              height: '52px',
              borderRadius: '20px',
              border: 'none',
              color: '#1D1C1D',
              fontSize: '20px',
              fontWeight: 700,
              letterSpacing: '0.1px',
            }}
            type="button"
          >
            다시 분석하기
          </button>
        )}
      </div>
    </div>
  );
}

export default B2CSolution;
